import request from './request.js';

/**
 * 
 * @param {*} isDivision 
 * @param {*} entityID accountID or userID depending if division or member carryForward
 * @returns 
 */
function getCarryForward(isDivision, entityID) {
    const options = {
        endpoint: isDivision ? `/accounts/${ entityID }/carryForward?isDivision=true` : `/user/${ entityID }/carryForward?isDivision=false`,
        method: 'GET'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * 
 * @param {*} isDivision 
 * @param {*} carryForwardID 
 * @returns 
 */
function removeCarryForward(isDivision, carryForwardID) {
    const options = {
        endpoint: isDivision ? `/accounts/carryForward/${ carryForwardID }` : `/user/carryForward/${ carryForwardID }`,
        method: 'DELETE',
        body: {
            isDivision
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 *
 * @param {*} isDivision
 * @param {*} amount
 * @param {*} entityID divisionID or userID depending if division or member carryForward
 * @param type
 * @returns
 */
function addCarryForward(isDivision, amount, entityID, type = null) {
    const options = {
        endpoint: isDivision ? `/accounts/carryForward` : `/user/carryForward`,
        method: 'POST',
        body: {
            isDivision,
            amount,
            entityID,
            ...(type ? { type } : {})
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

export {
    getCarryForward,
    removeCarryForward,
    addCarryForward
};